import {DOCUMENT_TYPE} from './constants';
import * as _ from 'lodash';

export function companyHasHRMDocuments(docTypes) {

    let hrmDocTypes = [DOCUMENT_TYPE.EXPENSE_CLAIM, DOCUMENT_TYPE.LEAVE_REQUEST, DOCUMENT_TYPE.TIMESHEET, DOCUMENT_TYPE.COST_REQUEST];
    return _.intersection(docTypes, hrmDocTypes).length > 0;

}